module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAEJJREFUKBVjYBgFOEOAESRTXFzcCqTygHhSb29vNTFiTCBFQADSxAOlQXwQwCsG0zgJqPALEINoGCBWDKZ+lKY4BADj2BXkLeHzSgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/more.png
// module id = uty8
// module chunks = 265